<template>
    <!--保险渠道-->
  <div>
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="保险渠道名称" style="width: 200px; margin-right: 3px;"></Input>
      <Button type="primary" style="margin-right: 3px;" size="small" @click="onFilterClick">查询</Button>
      <Button type="primary" size="small" @click="addInsurancechannelInfoModal=true">添加保险渠道</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <add-insurancechannel-info-modal v-model="addInsurancechannelInfoModal" @on-success="onSuccess"></add-insurancechannel-info-modal>
    <insurancechannel-info-modal v-model="insurancechannelInfoModal" :initValue="insurancechannelInfoId" @on-success="onSuccess"></insurancechannel-info-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name" v-model="webTableColumnsModal"></web-table-columns-modal>

  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'

  import AddInsurancechannelInfoModal from '@/view/crm/components/add-insurancechannel-info-modal'
  import InsurancechannelInfoModal from '@/view/crm/components/insurancechannel-info-modal'

  export default {
        name: "saleschannelinfo",
    components:{
      AddInsurancechannelInfoModal,
      InsurancechannelInfoModal,
    },
      data(){
          return{
            //增加保险渠道
            addInsurancechannelInfoModal:false,
            //保险渠道详细
            insurancechannelInfoModal:false,
            insurancechannelInfoId:null,

            webTableColumnsModal: false,
            menuList: [
              { title: '设置表格列', content: {} }
            ],

            pageFilter: 30,
            pagesizeopts:[30, 50,100,200],
            keywordFilter: null,
            tableHeight: 160,
            pageIndex: 1,
            sort: null,
            listLoadding: false,

            columns: [
              {
                title: 'ID',
                resizable: true,
                key: 'id',
                sortable: 'custom',
                tooltip: 'true',
                width: 130
              },
              {
                title: '保险渠道',
                resizable: true,
                key: 'name',
                ellipsis: 'true',
                width: 250
              },
              {
                title: '联系电话',
                resizable: true,
                key: 'telephoneNum',
                ellipsis: 'true',
                width: 180
              },
              {
                title: '联系地址',
                resizable: true,
                key: 'address',
                ellipsis: 'true',
                minWidth: 370
              },
              {
                title: '创建时间',
                resizable: true,
                sortable: 'custom',
                ellipsis: 'true',
                tooltip: 'true',
                key: 'createDatetime',
                width: 220,
                render: function (h, params) {
                  if (params.row.createDatetime) {
                    let d = new Date(params.row.createDatetime)
                    return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
                  }
                }
              },
              {
                title: '操作',
                resizable: true,
                key: 'action',
                align: 'left',
                ellipsis: 'true',
                fixed: 'right',
                width: 200,
                render: (h, params) => {
                  return h('div', [
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.insurancechannelInfoId = params.row.id
                          this.insurancechannelInfoModal = true
                        }
                      }
                    }, '详细信息'),
                  ])
                }
              }
            ]// cloumn

          }
      },
      methods:{
        onSuccess () {
          this.setPage(1)
        },
        onModifySuccess () {
          this.refreshPage(this.pageFilter)
        },
        onFilterClick () {
          this.setPage(1)
        },
        setPage (page) {
          console.log('setPage' + page)
          this.pageIndex = page
          this.listLoadding = true

          let queryParams = []
          let sortParam = null

          if (this.sort) {
            sortParam = genSortParam(this.sort.name, this.sort.asc)
          }

          store.dispatch('InsuranceChannelServ_GetPage', {
            params: null,
            urlparams: {
              q: queryParams,
              ps: this.pageFilter,
              p: page,
              ps: 50,
              keyword: this.keywordFilter,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        },
        // 刷新当前页
        refreshPage (value) {
          this.pageFilter = value
          this.setPage(this.pageIndex)
        },
        /**
         * 右键菜单点击回调
         */
        onContextMenuCallback (item) {
          if (item.title === '设置表格列') {
            this.webTableColumnsModal = true
          }
        },
        /**
         * 表格右键回调
         */
        onTableRightClick (e) {
          this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
        },
        sortChange ({ column, key, order }) {
          this.sort = {
            name: key,
            asc: order === 'asc'
          }
          this.refreshPage(this.pageFilter)
        },
      },
      computed: {
        totalElements () {
          if (store.getters.get_InsuranceChannel_GetPageResult) {
            return store.getters.get_InsuranceChannel_GetPageResult.totalElements
          } else {
            return 0
          }
        },
        content () {
          if (store.getters.get_InsuranceChannel_GetPageResult) {
            return store.getters.get_InsuranceChannel_GetPageResult.content
          } else {
            return []
          }
        },
        pageSize () {
          if (store.getters.get_InsuranceChannel_GetPageResult) {
            return store.getters.get_InsuranceChannel_GetPageResult.size
          } else {
            return 0
          }
        }
      },
      mounted () {
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          window.onresize = () => {
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          }
          this.setPage(1)
        })
      }
    }
</script>

<style scoped>

</style>
